module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAABqADAAQAAAABAAAACgAAAACuYNCkAAAAaklEQVQIHWNmYGBYCcSvgPghEKMANSDvBhD7oohCOTJA+hIQx2KTFAYKngTifJAkI4hAAjxA9kYgPsqEJAhisgMxSBLkGDiQBLIuAHE8XATIUADia0AcBMRwoAFk3QRid7gIlAHyoA26IABT0w2YczfeVAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/images/caret.png
// module id = 264
// module chunks = 0